const Divider = {
  baseStyle: {
    borderColor: "chakra-border-color",
    opacity: "1",
  },
};

export default Divider;
